import useUserContext from 'Contexts/user-context';
import Description from 'Shared/components/description';
import { useTranslation } from 'Shared/util/custom-hooks';
import styles from './user-section.css';


const UserSection = () => {
  const { user } = useUserContext();
  const t = useTranslation(x => x.acconomy);
  const tg = useTranslation(x => x.global);

  return (
    <div className={styles.container}>
      <h3>{tg.user}</h3>
      <Description text={t.onceYouHaveCreatedTheLinkForYourCompany} />
      <div className={styles.informationContainer}>
        <div>
          <div>
            <h5>{tg.company}</h5>
            <span>{user.activeCompany.name}</span>
          </div>
          <div>
            <h5>{tg.eMail}</h5>
            <span>{user.activeCompany.userEmail}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSection;
